import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AssetKind} from '../enum/asset.kind';
import {SystemEntity} from './system.entity';
import {EnvironmentKind} from '../enum/environment.kind';

@EntityTable('asset', 'a496a540-ec48-4a12-9ef1-31fc9e1e4790')
export class AssetEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.LONG)
    public kind: AssetKind;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Column(FieldTypeKind.STRING)
    public path: any;

    @Column(FieldTypeKind.FILE)
    public key: any;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

}
